import MuiAlert from '@mui/material/Alert';
export default MuiAlert;
export { alertClasses as muiAlertClasses } from '@mui/material/Alert';
